module.exports = __webpack_public_path__ + "static/vector-map-icon-6da814521f08c8461684ece07ac86300.png";